<template>
  <section class="entity-settings__edit">
    <div class="top-info">

      <div class="top-info-logo">
        {{ $t(`entity.logo`)}}
        <img v-if="!(entity.logo)" alt="Logo entidad" src="@/assets/images/placeholder.jpg">
        <img v-else alt="Logo entidad" :src="formEntity.logo">
      </div>

      <div class="top-info-entity">
        <div class="entity-name"> {{ $t(`entity.businessName`)}}
          <vs-input name="businessName"
                v-validate="'required'"
                :danger="this.errors.has('businessName')"
                :danger-text="this.errors.first('businessName')"
                size="large"
                label-placeholder="Razón Social"
                v-model="formEntity.businessName">
          </vs-input>
        </div>

        <div>
          {{ $t(`entity.commercialAddress`)}}
          <vs-input name="commercialAddress"
                v-validate="'required'"
                :danger="this.errors.has('commercialAddress')"
                :danger-text="this.errors.first('commercialAddress')"
                size="large"
                label-placeholder="Dirección Comercial"
                v-model="formEntity.commercialAddress">
          </vs-input>
        </div>

        <div>
          {{ $t(`entity.phone`)}}
          <vs-input name="entity-phone"
                v-validate="'required'"
                :danger="this.errors.has('entity-phone')"
                :danger-text="this.errors.first('entity-phone')"
                v-mask="'###-#######'"
                size="large"
                label-placeholder="Teléfono institucional"
                v-model="formEntity.phone">
          </vs-input>
        </div>
      </div>
    </div>

    <div class="bottom-info">
      <div class="data"> {{ $t(`entity.city`)}}
        <div class="input-group">
          <select name="city"
                  data-test="input-city"
                  v-validate="'required'"
                  :danger="this.errors.has('city')"
                  size="large"
                  :class="{changed: !!(this.formEntity.city)}"
                  v-model="formEntity.city">
            <option data-test="ciudad-opt" value="" disabled>Ciudad</option>
            <option :key="index" :value="city.name" :text="city.name" v-for="(city,index) in cities">{{ city.name }}</option>
          </select>
          <label data-test="ciudad-opt" for="state">Localidad</label>
          <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            <span> {{ this.errors.first('city') }}</span>
          </div>
        </div>
      </div>
      <div class="data"> {{ $t(`entity.country`)}}
          <input name="country"
                 v-model="formEntity.country"
                 v-validate="'required'"
                 disabled>
      </div>

                <!--|validateOnDB:organization,cuit-->
      <div class="data">
        {{ $t(`entity.cuit`)}}
        <vs-input name="cuit"
                v-validate="'required|length:13'"
                :danger="this.errors.has('cuit')"
                :danger-text="this.errors.first('cuit')"
                v-mask="'##-########-#'"
                size="large"
                label-placeholder="CUIT"
                v-model="formEntity.cuit">
        </vs-input>
      </div>
      <!--|validateOnDB:organization,email-->
      <div class="data">
        {{ $t(`entity.email`)}}
        <vs-input name="email"
                v-validate="'required|email'"
                :danger="this.errors.has('email')"
                :danger-text="this.errors.first('email')"
                type='email'
                size="large"
                label-placeholder="Correo electrónico institucional"
                v-model="formEntity.email">
        </vs-input>
      </div>
      <div class="data"> {{ $t(`entity.incomeTaxSituation`)}}
        <div class="input-group">
          <select name="income-tax-situation"
                  v-validate="'required'"
                  :danger="this.errors.has('income-tax-situation')"
                  size="large"
                  :class="{changed: !!(this.formEntity.incomeTaxSituation)}"
                  v-model="formEntity.incomeTaxSituation">
            <option value="" disabled>Situación frente al impuesto a las ganancias</option>
            <option :key="tax" :value="tax" :text="tax" v-for="tax in incomeTaxSituationList">{{ tax }}</option>
          </select>
          <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            <span> {{ this.errors.first('incomeTaxSituation') }}</span>
          </div>
        </div>
      </div>

      <div class="data"> {{ $t(`entity.ivaSituation`)}}
        <div class="input-group">
          <select name="iva-situation"
                  v-validate="'required'"
                  :danger="this.errors.has('iva-situation')"
                  size="large"
                  :class="{changed: !!(this.formEntity.ivaSituation)}"
                  v-model="formEntity.ivaSituation">
            <option value="" disabled>Situación frente al IVA</option>
            <option :key="iva" :value="iva" :text="iva" v-for="iva in ivaSituationList">{{ iva }}</option>
          </select>
          <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            <span> {{ this.errors.first('iva-situation') }}</span>
          </div>
        </div>
      </div>

      <!-- <div class="data"> {{ $t(`entity.mainActivity`)}} <input name="mainActivity" v-model="formEntity.mainActivity" disabled> </div> -->

      <div class="data"> {{ $t(`entity.state`)}}
        <div class="input-group">
          <select name="state"
                  data-test="provincia-opt"
                  v-validate="'required'"
                  :danger="this.errors.has('state')"
                  size="large"
                  @change="getCities($event.target.value)"
                  :class="{changed: !!(this.formEntity.state)}"
                  v-model="formEntity.state">
            <option value="" disabled>Provincia</option>
            <option :key="index" :value="state.name" :text="state.name" v-for="(state,index) in states">{{ state.name }}</option>
          </select>
          <label for="state">Provincia</label>
          <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            <span> {{ this.errors.first('state') }}</span>
          </div>
        </div>
      </div>

      <div class="data">
        {{ $t(`entity.zipcode`)}}
        <vs-input name="zipcode"
                data-test="input-codep"
                v-validate="'required|alpha_dash|min:4|max:6'"
                :danger="this.errors.has('zipcode')"
                :danger-text="this.errors.first('zipcode')"
                size="large"
                label-placeholder="CP"
                v-model="formEntity.zipcode">
        </vs-input>
      </div>

      <div class="data">
        Email de notificaciones
        <vs-input name="notification-email"
                  :danger="this.errors.has('notification-email')"
                  :danger-text="this.errors.first('notification-email')"
                  size="large"
                  v-validate="'email'"
                  label-placeholder="Email de notificaciones"
                  v-model="formEntity.notificationEmails">
        </vs-input>
      </div>
 
      <template v-if="entity.establishments.some(est => est.marketRole == 'seller')">
        <div class="data">
          Cantidad de Madres de Producción
          <vs-input name="mothers-for-production"
                    v-validate="'numeric'"
                    :danger="this.errors.has('mothers-for-production')"
                    :danger-text="this.errors.first('mothers-for-production')"
                    size="large"
                    label-placeholder="Cantidad de Madres de Producción"
                    v-model="formEntity.productionMothers">
          </vs-input>
        </div>
        <div class="data">
          Cantidad de animales enviados a faena por mes
          <vs-input name="slaughterQuantity"
                    v-validate="'numeric'"
                    :danger="this.errors.has('slaughterQuantity')"
                    :danger-text="this.errors.first('slaughterQuantity')"
                    size="large"
                    label-placeholder="Cantidad de animales enviados a faena por mes"
                    v-model="formEntity.slaughterQuantityPerMonth">
          </vs-input>
        </div>
      </template>
         <div class="data">
            Mostrar mi organización en el Ranking de Empresas
            <div>
                <input class="ranking-input" type="checkbox" v-model="formEntity.showInRanking">
            </div>
        </div>
      <div class="data" v-if="entity.establishments.some(est => est.marketRole == 'buyer')">
        Ruca
        <vs-input name="ruca"
                  v-validate="'required'"
                  :danger="this.errors.has('ruca')"
                  :danger-text="this.errors.first('ruca')"
                  v-mask="'#####'"
                  size="large"
                  label-placeholder="Matrícula RUCA"
                  v-model="formEntity.ruca">
        </vs-input>
      </div>
      <div class="data input-group">
        {{ $t(`entity.comments`)}}
        <textarea v-model="formEntity.comments" rows="4"></textarea> <!--{{ entity.comments }}-->
      </div>
    </div>

    <div class="edit-footer">
      <vs-button color="#e0e0e0" type="filled" @click="emitCancel">Cancelar</vs-button>
      <vs-button color="success" @click="updateEntity" type="filled" >Confimar</vs-button>
    </div>

  </section>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { Validator } from 'vee-validate'


const updateOrganization = gql`
  mutation updateOrganization($organizationId: Int!, $comments: String, $businessName: String, $zipcode: String, $incomeTaxSituation: String, $iibbSituation: String, $ivaSituation: String, $commercialAddress: String, $email: String, $phone: String, $country: String, $city: String, $state: String, $currentUserToken: String!, $notificationEmails: [String!], $productionMothers: Int, $slaughterQuantityPerMonth: Int, $ruca: String, $showInRanking: Boolean ) {
    updateOrganization(organizationId: $organizationId, comments: $comments, businessName: $businessName, zipcode: $zipcode, incomeTaxSituation: $incomeTaxSituation, iibbSituation: $iibbSituation, ivaSituation: $ivaSituation, commercialAddress: $commercialAddress, email: $email, phone: $phone, country: $country, city: $city, state: $state, currentUserToken: $currentUserToken, notificationEmails: $notificationEmails, productionMothers: $productionMothers, slaughterQuantityPerMonth: $slaughterQuantityPerMonth, ruca: $ruca, showInRanking: $showInRanking) {
      code
      success
      message
    }
  }
`
const fetchCountries = gql`
  query fetchCountries {
    fetchCountries {
      name
      id
    }
  }
`

const fetchStates = gql`
  query fetchStates($countryId: Int!) {
    fetchStates(countryId: $countryId) {
      name
      id
    }
  }
`

const fetchCities = gql`
  query fetchCities($stateId: Int!) {
    fetchCities(stateId: $stateId) {
      name
    }
  }
`

const SelectableAttributes = gql`
  query retrieveSelectableAttributes($object: String!, $attribute: String!) {
    retrieveSelectableAttributes(object: $object, attribute: $attribute) {
      code
      selectableAttributes
      message
      success
    }
  }
`


export default {
  name: 'edit-entity',
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formEntity: {country: '', ruca: '', productionMothers: '', slaughterQuantityPerMonth: ''},
      countries: [],
      states: [],
      cities: [],
      iibbSituationList: [],
      ivaSituationList: [],
      incomeTaxSituationList: []
    }
  },
  beforeMount () {
    this.formEntity = this.entity
    this.getCountries()
    this.getAttributeList("organization", "iibb_situation", "iibbSituationList")
    this.getAttributeList("organization", "iva_situation", "ivaSituationList")
    this.getAttributeList("organization", "income_tax_situation", "incomeTaxSituationList")
  },
  methods: {

    emitCancel() {
      this.$emit('emitCancel')
    },
    updateEntity () {
      this.$validator.validate().then(res => {
        if (res){
          axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
            query: print(updateOrganization),
            variables: {
              organizationId: this.formEntity.id,
              businessName: this.formEntity.businessName,
              zipcode: this.formEntity.zipcode,
              incomeTaxSituation: this.formEntity.incomeTaxSituation,
              ivaSituation: this.formEntity.ivaSituation,
              commercialAddress: this.formEntity.commercialAddress,
              email: this.formEntity.email,
              phone: this.formEntity.phone,
              city: this.formEntity.city,
              state: this.formEntity.state,
              comments: this.formEntity.comments,
              productionMothers: Number(this.formEntity.productionMothers),
              slaughterQuantityPerMonth: Number(this.formEntity.slaughterQuantityPerMonth),
              ruca: this.formEntity.ruca,
              notificationEmails: typeof(this.formEntity.notificationEmails) == 'string' ? [this.formEntity.notificationEmails] : this.formEntity.notificationEmails,
              currentUserToken: localStorage.getItem('USER_TOKEN'),
              showInRanking: this.formEntity.showInRanking
            }
          }).then(res => {
            if(!res.data.errors) {
              if (res.data.data.updateOrganization.code == "unauthorized") {
                this.$vs.notify({
                  title: 'No tiene permisos para realizar esta acción',
                  time: 3000,
                  //text: 'Por favor intente nuevamente',
                  color: '#DE3618',
                  position: 'top-right',
                  icon: 'error'
                })
              } else {
                this.$emit('updated')
              }
            } else {
              console.log('error')
            }
          })
        }
      })
    },
    getCountries () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchCountries)
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.countries = res.data.data.fetchCountries
          this.getStates('Argentina')
        }
      })
    },
    getStates (countryName) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchStates),
        variables: {
          countryId: this.getLocalizationId('countries', countryName)
        }
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.states = res.data.data.fetchStates
          if (this.formEntity.state) {
            this.getCities(this.formEntity.state)
          }
        }
      })
    },
    getCities (stateName) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchCities),
        variables: {
          stateId: this.getLocalizationId('states', stateName)
        }
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.cities = res.data.data.fetchCities
        }
      })
    },
    getLocalizationId (arrayName, name) {
      return this[arrayName].find(q => q.name === name).id
    },
    getAttributeList (objVariable, attrVariable, toArray){
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(SelectableAttributes),
        variables: {
          object: objVariable,
          attribute: attrVariable
        }
      }}).then( res => {
        if (!res.data.errors) {
          if (res.data.data.retrieveSelectableAttributes.success) {
            this[toArray] = res.data.data.retrieveSelectableAttributes.selectableAttributes
          }
        }
      })
    },
  }
}
</script>
<style scoped>

.ranking-input{
    box-shadow: none !important;
    width: 21px;
    height: 21px;
}
.ranking-input:hover{
    cursor: pointer;
}
</style>